import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getZoneGroupsAPI } from './api';

export const GET_ZONE_GROUPS = 'getZoneGroups';

export function useGetZoneGroups(zoneId) {
  const tenantId = getTenantIDBasedOnURL();

  const { data, isLoading, isFetching, isError } = useQuery([
    GET_ZONE_GROUPS, tenantId, zoneId,
  ], () => getZoneGroupsAPI(zoneId), {
    enabled: !!zoneId,
  });

  return {
    groups: data?.groups || [],
    isLoading,
    isFetching,
    isError,
  };
}

